"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryStock = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const product_entity_1 = require("../products/product.entity");
let InventoryStock = class InventoryStock {
    get quantityAvailable() {
        return this.quantityOnHand - this.quantityReserved;
    }
};
exports.InventoryStock = InventoryStock;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], InventoryStock.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => product_entity_1.Product, (p) => p.stockLocations, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof product_entity_1.Product !== "undefined" && product_entity_1.Product) === "function" ? _a : Object)
], InventoryStock.prototype, "product", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 80 }),
    tslib_1.__metadata("design:type", String)
], InventoryStock.prototype, "location", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], InventoryStock.prototype, "quantityOnHand", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], InventoryStock.prototype, "quantityReserved", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], InventoryStock.prototype, "reorderLevel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], InventoryStock.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], InventoryStock.prototype, "updatedAt", void 0);
exports.InventoryStock = InventoryStock = tslib_1.__decorate([
    (0, typeorm_1.Entity)('inventory_stock'),
    (0, typeorm_1.Unique)(['product', 'location'])
], InventoryStock);
